/**
 * Angular JS Common Controller
 *
 * @category Controllers
 * @package Common
 * @author Chris <chriswelland@yellostudio.co.uk>
 * @copyright (c) 2016, Yello Studio
 * @version 0.1
 */

(function(){

    'use strict';

    var ContactController = function($scope, $http){

        var _this = this;

        $scope.show_address = false;

        // Construct the ContactController
        this.construct = function(){
            _this.getRetailers();
        };

        // Get retailers
        this.getRetailers = function(){

            $http({ url:'/api/retailers', type:'GET' })
                .then(function(response){
                    if(response.error){
                        console.log("ERROR: Unable to retrieve retailers");
                    } else {
                        $scope.retailers = response.data.retailers;
                    }
                }, function(response){
                    console.log("ERROR: Endpoint not functioning");
                });
        };


        $('.contact-form select').change(function(e){
          var $val = $(this).val()
          if($val == ""){
            $scope.show_address = false;
          }else{
            $scope.show_address = true;
          }
        });

        this.construct.apply(this, arguments);

    };

    angular.module('App').controller('ContactController', ContactController);

})();
